import React, { FC } from "react";
import { Modal, Table, Tag, Typography } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { CreateFortnoxInvoiceResponse } from "shared/api";
import { useFortnoxCompanyColumns } from "shared/hooks/useFortnoxCompanyColumns";
import { useFortnoxMaterialColumns } from "shared/hooks/useFortnoxMaterialColumns";

const { Title, Text } = Typography;

interface FortnoxInvoiceResultModalProps {
  visible: boolean;
  onClose: () => void;
  result: CreateFortnoxInvoiceResponse | null;
}

export const FortnoxInvoiceResultModal: FC<FortnoxInvoiceResultModalProps> = ({
  visible,
  onClose,
  result,
}) => {
  if (!result) return null;

  const companyColumns = useFortnoxCompanyColumns();
  const materialColumns = useFortnoxMaterialColumns();

  return (
    <Modal
      title="Fortnox Invoice Creation Result"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1200}
      centered
    >
      <div className="space-y-4">
        <div className="flex items-center gap-4 p-4 bg-gray-50 rounded">
          <div className="flex items-center gap-2">
            <Text strong>Created Fortnox Invoice:</Text>
            {result.ok ? (
              <Tag color="success" icon={<CheckCircleOutlined />}>
                Yes
              </Tag>
            ) : (
              <Tag color="error" icon={<CloseCircleOutlined />}>
                No
              </Tag>
            )}
          </div>
          <div className="flex items-center gap-2">
            <Text strong>Invoice Already Existed:</Text>
            {result.already_existed ? (
              <Tag color="warning">Yes</Tag>
            ) : (
              <Tag color="default">No</Tag>
            )}
          </div>
          {result.fortnox_created_invoice_number && (
            <div className="flex items-center gap-2">
              <Text strong>Invoice Number:</Text>
              <Tag color="blue">{result.fortnox_created_invoice_number}</Tag>
            </div>
          )}
        </div>

        {result.company_statuses && result.company_statuses.length > 0 && (
          <div>
            <Title level={5}>Company Status</Title>
            <Table
              dataSource={result.company_statuses}
              columns={companyColumns}
              rowKey={(record, index) =>
                `${record.fortnox_customer_number}-${index}`
              }
              pagination={false}
              size="small"
            />
          </div>
        )}

        {result.material_statuses && result.material_statuses.length > 0 && (
          <div>
            <Title level={5}>Material Status</Title>
            <Table
              dataSource={result.material_statuses}
              columns={materialColumns}
              rowKey={(record, index) =>
                `${record.fortnox_article_number}-${index}`
              }
              pagination={false}
              size="small"
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
